import React from 'react'
import { Box, Flex, Text, Button } from '@chakra-ui/react'
import { Link } from 'gatsby'
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'
import { Image } from '@chakra-ui/react'
import ReactLogo from '../../assets/logo.svg'
import styled from 'styled-components'
import { red } from 'chalk'

const MenuItems = ({ children, isLast, to = '/' }) => {
  return (
    <Text
      display="block"
      as={Link}
      to={to}
      color={['#83B53C', '#83B53C', '#ffffff', '#ffffff']}
      p={['12px 0px', '12px 0px', '13px 7px 13px 10px', '10px 18px']}
      width={['100%', '100%', '', '']}
      textAlign={['center', 'center', '', '']}
      whiteSpace={['nowrap', 'nowrap', 'nowrap', 'nowrap']}
      border={[
        'none',
        'none',
        '1px solid transparent',
        '1px solid transparent',
      ]}
      borderBottom={[
        '1px solid rgb(0, 0, 0, 0.1)',
        '1px solid rgb(0, 0, 0, 0.1)',
        '',
        '',
      ]}
      _activeLink={[
        {},
        {},
        { borderBottom: '1px solid white' },
        {
          borderBottom: '1px solid white',
        },
      ]}
    >
      {children}
    </Text>
  )
}

export const Hamburger = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 30px;
  height: 3px;
  transition: all 0.3s linear;
  align-self: center;
  position: relative;
  transform: ${(props) => (props.open ? 'rotate(-45deg)' : 'inherit')};

  ::before,
  ::after {
    width: 30px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.white};
    content: '';
    position: absolute;
    transition: all 0.3s linear;
  }

  ::before {
    transform: ${(props) =>
      props.open ? 'rotate(-90deg) translate(-10px, 0px)' : 'rotate(0deg)'};
    top: -10px;
  }

  ::after {
    opacity: ${(props) => (props.open ? '0' : '1')};
    transform: ${(props) => (props.open ? 'rotate(90deg) ' : 'rotate(0deg)')};
    top: 10px;
  }
`

const Header = (props) => {
  const [show, setShow] = React.useState(false)
  const toggleMenu = () => {
    setShow(!show)
    console.log(show)
  }

  return (
    <Flex
      as="nav"
      align={['center', 'center', 'flex-start', 'flex-start']}
      justify="space-between"
      wrap="wrap"
      w="100%"
      //   p={6}
      bg={['transparent', 'transparent', 'transparent', 'transparent']}
      color={['#ffffff', '#ffffff', '#ffffff', '#ffffff']}
      //   zIndex={11}
      position="relative"
      {...props}
    >
      <Flex align="center" marginBottom={['15px', '15px', '0px', '0px']}>
        <Image
          src={ReactLogo}
          alt="Logo"
          to="/"
          w={'100%'}
          maxWidth={['100px', , , '153px']}
          cursor={'pointer'}
        />
      </Flex>

      <Box display={{ base: 'block', md: 'none' }} onClick={toggleMenu}>
        {show ? <Hamburger open /> : <Hamburger />}
      </Box>

      <Box
        display={{ base: show ? 'block' : 'none', md: 'block' }}
        flexBasis={{ base: '100%', md: 'auto' }}
        position={['absolute', 'absolute', 'initial', 'initial']}
        top={['72px', '72px', '', '']}
        left={['0', '0', '', '']}
        right={['0', '0', '', '']}
        zIndex="111"
      >
        <Flex
          align={['center', 'center', 'center', 'center']}
          justify={['center', 'center', 'flex-end', 'flex-end']}
          direction={['column', 'column', 'row', 'row']}
          background={['#ffffff', '#ffffff', 'transparent', 'transparent']}
        >
          <MenuItems to="/homepage">Home</MenuItems>
          <MenuItems to="/our-vision">Vision</MenuItems>
          <MenuItems to="/properties">Properties</MenuItems>
          <MenuItems to="/investment">Investment</MenuItems>
          <MenuItems to="/lifestyle">Lifestyle</MenuItems>
          <MenuItems to="/residences">Residences</MenuItems>
          <MenuItems to="/contact-us-page">Contact us</MenuItems>
        </Flex>
      </Box>
    </Flex>
  )
}

export default Header
